import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

const useManualBooking = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const manualBooking = async (requestData) => {
    setLoading(true);
    var requestBody = {
      supplyId: requestData?.supplyId,
      date: requestData?.date,
      startTime: requestData?.startTime,
      guestName: requestData?.guestName,
      // What the guest gave beside the name; an empty field is left out (docs/MANUAL_BOOKING_CONTACT.md).
      guestEmail: requestData?.guestEmail?.trim() || undefined,
      guestPhoneNumber: requestData?.guestPhoneNumber?.trim() || undefined,
      // Whose calendar the guest goes on (docs/MULTI_PROVIDER.md).
      providerId: requestData?.providerId
    };
    try {
      const url = `/v1/tenants/${tenantId}/bookings/manual-booking`;
      await apiClient.post(url, requestBody);
      return true;
    } catch (error) {
      handleError(error, Routes.DASHBOARD);
    } finally {
      setLoading(false);
    }
  };

  return { manualBooking, loading };
};

export default useManualBooking;